export function replacePipesWithDashes(value: string): string {
  return value.replaceAll('|', '-');
}
